<avla-modal name="newUser" type="right" [icon]="{ type: 'class', icon: 'close', class: 'material-symbols-rounded' }" [onClose]="reInit.bind(this)">
    <div class="avla_modal_section__header mt-16 flex flex-col items-center" *ngIf="status == 'default' || status == 'loading'">
      <span class="material-symbols-rounded"> person_add </span>
      <p class="text-2xl font-semibold text-light-blue">
        Nuevo usuario
      </p>
    </div>
    <div class="avla_modal_section__body" [ngClass]="{'overflow-y-scroll max-h-[50vh]': height <= 680}" >
      <div *ngIf="status == 'default'">
      <form [formGroup]="newUserForm">
        <div class="w-[380px] mx-auto flex flex-col gap-4">
          <avla-input [form]="newUserForm" id="rut" type="rut" label="RUT"
            [required]="true"></avla-input>
          <avla-input [form]="newUserForm" id="firstName" type="text" label="Primer nombre"
            [required]="true"></avla-input>
          <avla-input [form]="newUserForm" id="secondName" type="text" label="Segundo nombre"
          ></avla-input>
          <avla-input [form]="newUserForm" id="fatherLastname" type="text" label="Apellido paterno"
            [required]="true"></avla-input>
          <avla-input [form]="newUserForm" id="motherLastname" type="text" label="Apellido materno"
            [required]="true"></avla-input>
          <avla-input [form]="newUserForm" id="email" type="text" label="Correo"
            [required]="true"></avla-input>
            <avla-select
            [form]="newUserForm"
            [values]="roles"
            id="role"
            [arrow]="{
              type: 'class',
              icon: 'expand_more',
              change: '',
              class: 'material-symbols-rounded',
              error: ''
            }"
            label="Rol de usuario"
            [required]="true"
          ></avla-select>
          <avla-button
            class="avla-btn-primary avla-btn-flat-label-md flat-design-button mx-auto"
            [disabled]="newUserForm.invalid"
            theme="primary"
            label="Registrar"
            (click)="register()"
          ></avla-button>
        </div>
      </form>
    </div>
      <div *ngIf="status == 'loading'" class="flex flex-col justify-center items-center">
        <p class="text-blue-700 text-center text-lg not-italic font-medium leading-5 mt-8">¡Un Momento!</p>
        <img src="./assets/gif/spinner-avlabaja.gif" alt="GIF" class="w-20 h-20 my-8">
        <p class="text-center text-gray-700 text-lg not-italic font-normal leading-5">Registrando información</p>
      </div>
      <div *ngIf="status == 'success'" class="mt-16 flex flex-col items-center">
        <div class="flex pt-16 flex-col justify-center items-center self-stretch">
          <img src="./assets/svg/success-modal.svg" alt="success-modal-svg">
        </div>
        <p class="text-blue-700 text-center text-2xl not-italic font-semibold leading-7 mt-8" >¡Bien!</p>
        <p class="text-gray-700 text-center text-lg not-italic font-normal leading-5 mt-8">Usuario registrado con éxito</p>
        <avla-button 
        class="avla-btn-primary avla-btn-flat-label-md flat-design-button mx-auto mt-8" theme="primary" label="Continuar" (click)="close()">
        </avla-button>
      </div>
      <div *ngIf="status == 'error'" class="flex pt-16 flex-col justify-center items-center self-stretch">
        <div class="mt-16">
          <img src="./assets/svg/error-modal.svg" alt="success-modal-svg">
        </div>
        <p class="text-gray-800 text-center text-2xl not-italic font-semibold leading-7 my-8">¡Lo sentimos!</p>
        <p class="text-gray-700 text-center text-lg not-italic font-normal leading-5">Ocurrió un error al registrar el usuario</p>
        <p class="text-center text-lg not-italic font-normal leading-5 my-8">Inténtalo nuevamente, si el problema <br> persiste comunícate con <br> 
          <a href="mailto:contacto@avla.com" class="text-blue-700 text-lg not-italic font-normal leading-5">contacto@avla.com</a></p>
          <avla-button 
          class="avla-btn-primary avla-btn-flat-label-md flat-design-button mx-auto mt-8" theme="primary" label="Reintentar" (click)="register()">
          </avla-button>
      </div>
    </div>
</avla-modal>